import { createFileRoute } from '@tanstack/react-router';
import { Braces, LayoutTemplate, MonitorSmartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  MarketingCta,
  MarketingPageHeader,
  MarketingShell,
} from '../features/marketing/marketing-shell';
import { useMarketingMetadata } from '../features/marketing/marketing-metadata';

export const Route = createFileRoute('/about')({ component: AboutPage });

function AboutPage() {
  const { t } = useTranslation();
  useMarketingMetadata(t('marketing.about.metaTitle'), t('marketing.about.description'));
  return (
    <MarketingShell>
      <MarketingPageHeader
        eyebrow={t('marketing.nav.about')}
        title={t('marketing.about.title')}
        description={t('marketing.about.description')}
      />
      <section className="about-story">
        <div>
          <h2>{t('marketing.about.whyTitle')}</h2>
          <p>{t('marketing.about.whyDescription')}</p>
          <p>{t('marketing.about.whyDescription2')}</p>
        </div>
        <div className="about-principles">
          {[MonitorSmartphone, LayoutTemplate, Braces].map((Icon, index) => (
            <article key={index}>
              <Icon aria-hidden="true" />
              <h3>{t(`marketing.about.principle${index + 1}Title`)}</h3>
              <p>{t(`marketing.about.principle${index + 1}Description`)}</p>
            </article>
          ))}
        </div>
      </section>
      <MarketingCta />
    </MarketingShell>
  );
}
